import React from 'react';
import PatternImage from './img/pattern5.png';

const CallToAction = ({ selected = [] }) => {
  const selectedOptions = selected.map(item => {
    if (!item.selectedOption) {
      return item;
    }
    const itemWithOptions = {
      ...item.selectedOption,
      cantidad: item.cantidad,
      horas: item.horas
    };
    return itemWithOptions;
  });
  const consumoTotal = selectedOptions.map(
    item => Number(item.potencia) * Number(item.cantidad) * Number(item.horas)
  );
  const total = consumoTotal.reduce((acc, current) => acc + current, 0);
  return (
    <section
      className="bg-sp-yellow g-color-white g-pa-50 g-pt-100 g-pb-100"
      style={{ backgroundImage: `url(${PatternImage})` }}
    >
      <div className="text-center text-uppercase u-heading-v2-4--bottom g-brd-primary g-mb-20">
        <h3 className="u-heading-v2__title g-line-height-1 g-letter-spacing-2 g-font-size-20 g-font-size-26--md g-color-white mb-0">
          Pregúntanos lo que quieras!
        </h3>
      </div>
      <div className="d-md-flex justify-content-md-center text-center">
        <div className="align-self-md-center">
          <p className="lead g-font-weight-700 g-mr-20--md g-mb-15 g-mb-0--md">
            Tienes dudas? Necesitas cotizar? <br />Solo quieres hablarnos?
          </p>
        </div>
      </div>
      <div className="text-center g-mt-30">
        <a
          href={
            selectedOptions.length > 0
              ? `https://www.solar-power.cl/contacto?product=SP${total}`
              : 'https://www.solar-power.cl/contacto'
          }
          className="btn btn-lg bg-sp-blue text-uppercase g-font-weight-700 g-font-size-16"
          style={{ color: 'white' }}
        >
          Contáctanos
        </a>
      </div>
    </section>
  );
};

export default CallToAction;



// WEBPACK FOOTER //
// ./src/components/Home/CallToAction/index.js